import { Text, Img, Heading, Button } from "./..";
import React, { useEffect, useMemo, useState } from "react";
import c, { API_DOMAIN_IMG, API_DOMAIN } from "config";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { formatPrice } from "utils/formatPrice";

import ApproveOfferByProviderPopup from "components/ApproveOfferByProviderPopup";
import { bg, te } from "date-fns/locale";

const COLS = [
  { key: "star", title: "דגם הרכב", w: "minmax(76px, 8%)" },
  { key: "buyer", title: "חברה", w: "minmax(68px, 7%)" },
  { key: "rate", title: "שנת ייצור", w: "minmax(78px, 8%)" },
  { key: "date", title: "גיר", w: "minmax(66px, 7%)" },
  { key: "kilometer", title: "קילומטר", w: "minmax(78px, 7%)" },
  { key: "reserved", title: "יד", w: "minmax(48px, 5%)" },
  { key: "pickup", title: "תאריך", w: "minmax(88px, 10%)" },
  { key: "payEnd", title: "הצעת מחיר", w: "minmax(108px, 9%)" },
  { key: "price", title: "מיועד ל", w: "minmax(108px, 10%)" },
  { key: "action", title: "סטטוס", w: "minmax(96px, 10%)" },
  { key: "action2", title: "ביצוע", w: "minmax(112px, 8%)" },
  { key: "action3", title: "פעולה", w: "minmax(132px, 11%)" },
];

const statusMap = {
  0: { txt: "ממתין להצעה",clr: "rgb(214, 31, 31)", bg: "rgb(255, 233, 233)"    },
  1: { txt: "ממתין לאישור", clr: "rgb(214, 31, 31)", bg: "rgb(255, 233, 233)" },
  2: { txt: "מאושר", clr: "rgb(119, 172, 59)", bg: "rgb(237, 255, 216)" },
  3: { txt: "הצעה שנדחתה", clr: "rgb(48, 49, 49)", bg: "rgb(233, 233, 233)" },
  4: { txt: "ארכיון", clr: "rgb(48, 49, 49)", bg: "rgb(233, 233, 233)" },
  5: { txt: "לא מעונין", clr: "rgb(48, 49, 49)", bg: "rgb(233, 233, 233)" },
  6: { txt: "העסקה נסגרה ברכישה מידית", clr: "rgb(48, 49, 49)", bg: "rgb(233, 233, 233)" },
};

export default function CarsTable({
  cars,
  car,
  rows,
  onOfferApproved,
  updateShowApprovedOfferPopup,
  setSelectedOffer,
  currentUser,
  onUpdate = () => {},
  setSelectedCar,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const [showApprovedOfferPopuop, setShowApprovedOfferPopup] = useState(false);

  const handleClick = (id) => {
    if (location.pathname.includes("/dashboard-dealer")) {
      navigate(`/dealer-cars/${id ?? car.car_id}`);
    } else {
      navigate(`${id}`);
    }
  };
const userType = Number(currentUser?.user_type);

  useEffect(() => {
  }, []);

  const template = COLS?.map((c) => c.w).join(" ");
  const tableMinWidth = "1158px";

  const handlePopupClose = () => {
    setShowApprovedOfferPopup(false);
  };

  const approveOffer = async (offer) => {
    try {
      await axios.post(
        `${API_DOMAIN}/offer/approveOfferByProvider`,
        { offer_id: Number(offer.id) },
        { headers: { "Content-Type": "application/json" } }
      );

      onOfferApproved(car?.id, offer.id);

      setSelectedOffer(offer);
      setSelectedCar(car);
      updateShowApprovedOfferPopup(true);
    } catch (err) {
      console.error(err);
      alert("אירעה שגיאה באישור ההצעה");
    }
  };

  const markNotInterested = async (carId) => {
    try {
      await axios.post(`${API_DOMAIN}/car/markNotInterested`, {
        car_id: carId,
        user_id: currentUser.id,
      });
      onUpdate(carId, 5);
    } catch (err) {
      console.error(err);
      alert("שגיאה בסימון 'לא מעונין'");
    }
  };

  const handleApproveClick = (car) => {
    setSelectedCar(car);
    setShowApprovedOfferPopup(true);
  };

  // פונקציה להמרת תאריכים לפורמט DD/MM/YY
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const removeNotInterested = async (carId) => {
    try {
      await axios.post(`${API_DOMAIN}/car/removeNotInterested`, {
        car_id: carId,
        user_id: currentUser.id,
      });
      onUpdate(carId, 0);
    } catch (err) {
      console.error(err);
    }
  };

  /* =========================
     ✅ SORTING (מיון עמודות)
     ========================= */

  const [sortKey, setSortKey] = useState(null); // key מתוך COLS
  const [sortDir, setSortDir] = useState("asc"); // 'asc' | 'desc'

  const parseNumber = (v) => {
    if (v === null || v === undefined) return null;
    const s = String(v).replace(/[^\d.-]/g, "");
    if (!s) return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  };

  const parseDateValue = (v) => {
    if (!v) return null;
    const d = new Date(v);
    return isNaN(d) ? null : d.getTime();
  };

  const normalizeString = (v) => {
    if (v === null || v === undefined) return "";
    return String(v).trim().toLowerCase();
  };

  const getDisplayStatus = (row) => {
    // כמו אצלך בלוגיקה
    return row.offer_status === 0 && row.approved_other === 1
      ? (Number(row.immediate_purchase_closed ?? row.immediatePurchaseClosed ?? 0) === 1 ? 6 : 4)
      : row.offer_status ?? 0;
  };

  const parseAuctionTime = (value) => {
    if (!value) return 0;
    const parsed = new Date(String(value).replace(" ", "T")).getTime();
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getAuctionDisplay = (row) => {
    const isAuction =
      Number(row.is_auction ?? row.isAuction ?? 0) === 1 || row.is_auction === true;
    if (!isAuction) return null;

    const startMs = parseAuctionTime(
      row.auction_start_datetime_iso ??
        row.auction_start_at_iso ??
        row.auction_start_datetime ??
        row.auction_start_at
    );
    const endMs = parseAuctionTime(
      row.auction_active_until_iso ??
        row.auction_end_time_iso ??
        row.auction_active_until ??
        row.auction_end_time ??
        row.auction_end_at
    );
    const status = String(row.auction_status ?? row.status_auction ?? "").toLowerCase();
    const hasEnded =
      Number(row.auction_has_ended ?? row.auctionHasEnded ?? 0) === 1 ||
      Boolean(row.auction_finalized_at) ||
      ["ended", "finalized"].includes(status);
    const isOpen =
      !hasEnded &&
      (Number(row.auction_is_open ?? row.auctionIsOpen ?? 0) === 1 ||
        (startMs > 0 && (startMs > Date.now() || (endMs > 0 && endMs > Date.now()))));

    if (!isOpen) return null;

    return {
      txt: startMs > Date.now() ? "המכרז טרם התחיל" : "מכרז פעיל",
      clr: "rgb(255, 140, 66)",
      bg: "rgb(255, 242, 230)",
    };
  };

  const getOfferComparable = (row) => {
    const displayStatus = getDisplayStatus(row);
    const isWaitingForOffer = displayStatus === 0;

    // אם ממתין להצעה – ממיינים לפי מחיר מומלץ
    if (isWaitingForOffer) return parseNumber(row.asking_price);

    // אחרת: טווח הצעות או מחיר
    const offerText = row.offer_range ?? row.offered_price ?? null;
    if (!offerText) return null;

    const s = String(offerText);
    if (s.includes("-")) {
      // "50-500" => ניקח את המינימום כמיון
      const [a] = s.split("-");
      return parseNumber(a);
    }
    return parseNumber(s);
  };

  const getSortValue = (row, key) => {
    switch (key) {
      case "star": // דגם הרכב
        return normalizeString(row.model);

      case "buyer": // חברה
        return normalizeString(row.manufacturer);

      case "rate": // שנת ייצור
        return parseNumber(row.year);

      case "date": // גיר
        return normalizeString(row.gearbox);

      case "city": // קילומטר
        return parseNumber(row.kilometer);

      case "reserved": // יד
        return parseNumber(row.hand);

      case "pickup": // תאריך
        return parseDateValue(row.creation_date);

      case "payEnd": // הצעת מחיר (לוגיקה מורכבת)
        return getOfferComparable(row);

      case "price": // מיועד ל (פירוק/שיקום)
        return Number(row.sale_type_id) === 1 ? "פירוק" : "שיקום";

      case "action": { // סטטוס
        const displayStatus = getDisplayStatus(row);
        const auctionDisplay = getAuctionDisplay(row);
        return normalizeString(auctionDisplay?.txt || statusMap[displayStatus]?.txt || "");
      }

      case "action2":
        // ביצוע – אין ערך אמיתי למיון (אפשר להחזיר 0 תמיד)
        return 0;

      case "action3":
        // מכרז – אם קיים אצלך שדה is_auction / isAuction וכו'
        return parseNumber(row.is_auction ?? row.isAuction);

      default:
        return "";
    }
  };

  const compareValues = (a, b) => {
    // Nulls תמיד בסוף
    const aNull = a === null || a === undefined || a === "";
    const bNull = b === null || b === undefined || b === "";
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;

    // מספרים
    if (typeof a === "number" && typeof b === "number") return a - b;

    // כל השאר כמחרוזת
    return String(a).localeCompare(String(b), "he", { numeric: true, sensitivity: "base" });
  };

  const sortedCars = useMemo(() => {
    const list = Array.isArray(cars) ? [...cars] : [];
    if (!sortKey) return list;

    list.sort((ra, rb) => {
      const va = getSortValue(ra, sortKey);
      const vb = getSortValue(rb, sortKey);
      const diff = compareValues(va, vb);
      return sortDir === "asc" ? diff : -diff;
    });

    return list;
  }, [cars, sortKey, sortDir]);

  const sortAsc = (key) => {
    setSortKey(key);
    setSortDir("asc");
  };

  const sortDesc = (key) => {
    setSortKey(key);
    setSortDir("desc");
  };

  return (
    <div>
      <div className="mt-2 flex w-full flex-col gap-2.5 self-end">
        <div className="flex items-start gap-[38px] md:ml-0 md:flex-col">
          <div className="w-[100%]">
            <div className="flex justify-center md:mx-0 md:flex-col">
              <div dir="rtl" className="w-full overflow-x-auto">
                {/* HEADER */}
                <div
                  className="grid items-center bg-white sticky top-0 z-10"
                  style={{
                    gridTemplateColumns: template,
                    borderBottom: "1px solid #E9E9E9",
                    minWidth: tableMinWidth,
                  }}
                >
                  {COLS?.map((c) => (
                    <div
                      key={c.key}
                      className="flex items-center justify-center py-2 text-sm font-assistant font-bold relative gap-2 select-none"
                    >
                      <span>{c.title}</span>

                      {/* חיצים למיון */}
                      <div style={{ width: "8px" }} className="flex flex-col items-center">
                        <button
                          type="button"
                          onClick={() => sortAsc(c.key)}
                          className="leading-none"
                          title="מיון עולה"
                        >
                          <img
                            src="/images/img_vector_red_a700_03_9.svg"
                            alt="up-arrow"
                            className="mb-0.5"
                            style={{
                              opacity: sortKey === c.key && sortDir === "asc" ? 1 : 0.45,
                            }}
                          />
                        </button>

                        <button
                          type="button"
                          onClick={() => sortDesc(c.key)}
                          className="leading-none"
                          title="מיון יורד"
                        >
                          <img
                            src="/images/img_vector_red_a700_03_10.svg"
                            alt="down-arrow"
                            className="mt-0.5"
                            style={{
                              opacity: sortKey === c.key && sortDir === "desc" ? 1 : 0.45,
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ROWS */}
                {sortedCars?.map((row, i) => {
                  const displayStatus = getDisplayStatus(row);
                  const auctionDisplay = getAuctionDisplay(row);
                  const { txt, clr, bg } = auctionDisplay || statusMap[displayStatus] || { txt: "", clr: "#666" };
                  const isWaitingForOffer = !auctionDisplay && displayStatus === 0;

                  const offerText = row.offer_range ?? row.offered_price ?? null;

                  return (
                    <div
                      key={i}
                      className="grid items-center gap-0 text-[15px]"
                      style={{
                        gridTemplateColumns: template,
                        borderBottom: "1px solid #E9E9E9",
                        height: "4rem",
                        margin: "0.5rem 0",
                        minWidth: tableMinWidth,
                      }}
                    >
                      {/* דגם */}
                      <span className="flex justify-center items-center">
                        {row.model || "-"}
                      </span>

                      {/* חברה */}
                      <span className="text-center relative">
                        {row.manufacturer || "-"}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* שנה */}
                      <span className="flex justify-center relative">
                        {row.year}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* גיר */}
                      <span className="text-center relative">
                        {row.gearbox}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* קילומטר */}
                      <span className="text-center relative">
                        {row.kilometer}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* יד */}
                      <span className="flex justify-center relative">
                        {row.hand}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* תאריך */}
                      <span className="text-center relative">
                        {formatDate(row.creation_date)}
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* הצעת מחיר */}
                      {isWaitingForOffer ? (
                        <div
                          style={{
                            opacity: 0.8,
                            zIndex: 999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Heading
                            size="headingxl"
                            className="!font-heebo text-[14px] font-bold ml-2"
                            style={{ textAlign: "center", fontWeight: "400" }}
                          >
                                         מחיר מומלץ: ₪{formatPrice(Number(row.asking_price))}

                          </Heading>
                        </div>
                      ) : offerText ? (
                        <div style={{ opacity: 0.8, zIndex: 999 }}>
                          <Heading
                            size="headingxl"
                            className="!font-heebo text-[14px] ml-2"
                            style={{ textAlign: "center", fontWeight: "400" }}
                          >
                            {String(offerText).includes("-")
                              ? "טווח הצעות: " + offerText
                              : "מחיר ההצעה: ₪" + offerText}
                          </Heading>
                        </div>
                      ) : (
                        <div style={{ opacity: 0.8, zIndex: 999 }}>
                          <Heading
                            size="headingxl"
                            className="!font-heebo text-[14px] ml-2"
                            style={{ textAlign: "center" }}
                          >
                            --------
                          </Heading>
                        </div>
                      )}

                      {/* מיועד ל */}
                      <span className="flex items-center justify-center relative w-full">
                        <Button
                          shape="round"
                          className="min-w-[116px] gap-2 rounded-[14px] px-[18px] font-medium capitalize !text-black-900 flex items-center"
                        >
                          <Img
                            src={
                              row.sale_type_id == 1
                                ? "/images/total.svg"
                                : "/images/img_television_red_a700_03_2.svg"
                            }
                            alt="Television"
                          />
                          {Number(row.sale_type_id) === 1 ? "פירוק" : "שיקום"}
                        </Button>
                        <div className="absolute right-0 top-0 bottom-0 w-px bg-gray-300" />
                      </span>

                      {/* סטטוס */}
                        <span className="flex items-center justify-center relative w-full">
                          <Button
                            size="lg"
                            shape="round"
                            style={{
                        //      border: "1px solid",
                              borderColor: clr,
                              backgroundColor: bg,
                                color: clr,
                              fontSize: "12px",
                              height: "auto",
                            }}
                            className="px-3 py-1 rounded-[5px] text-[12px] font-semibold leading-none"
                          >
                            {txt}
                          </Button>
                        </span>
                   
                      {/* ביצוע – “לא מעונין / הסר” */}
                      <span className="flex justify-center px-2">
                        <div className="flex w-full items-center justify-center">
                          {currentUser?.user_type === 3 && (
                            displayStatus === 0 ? (
                              <Button
                                size="lg"
                                shape="round"
                                onClick={() => markNotInterested(row.id)}
                                style={{
                                  border: "1px solid #666",
                                  color: "#666",
                                  fontSize: "12px",
                                  height: "auto",
                                }}
                                className="w-[96px] py-1.5 gap-2 rounded-[16px] font-semibold whitespace-normal text-center leading-tight"
                              >
                                העבר לארכיון
                              </Button>
                            ) : displayStatus === 5 ? (
                              <Button
                                size="lg"
                                shape="round"
                                onClick={() => removeNotInterested(row.id)}
                                style={{
                                  border: "1px solid #666",
                                  color: "#666",
                                  fontSize: "12px",
                                  height: "auto",
                                }}
                                className="w-[96px] py-1.5 gap-2 rounded-[16px] font-semibold whitespace-normal text-center leading-tight"
                              >
                                הסר מארכיון
                              </Button>
                            ) : (
                              <span style={{ width: 14 }} />
                            )
                          )}
                        </div>
                      </span>

                      {/* לצפיה */}
                      <span
                        onClick={() => {
                          handleClick(row?.id);
                        }}
                        className="flex items-center justify-center relative w-full cursor-pointer gap-2 px-2"
                      >
                        <h6 className="text-black-900_03 font-assistant text-[16px] font-semibold leading-tight lg:text-[13px]">
                          לצפיה במודעה
                        </h6>
                        <img
                          className="h-[14px] shrink-0"
                          src="/images/img_settings_black_900.svg"
                          alt="Settings"
                        />
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
